import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { logoutAndRedirect } from '../../actions/user'

export function requireAuthentication (Component) {
  const AuthenticatedComponent = props => {
    const dispatch = useDispatch()
    useEffect(() => {
      if (!sessionStorage.getItem('oef-token')) {
        dispatch(logoutAndRedirect(false, true))
      }

      window.scrollTo(0, 0)
    })

    return (
      <div>
        {props.isAuthenticated === true
          ? (<Component {...props} />)
          : null}
      </div>
    )
  }

  AuthenticatedComponent.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    policiesToAccept: PropTypes.string
  }

  const mapStateToProps = state => ({
    token: state.user.token,
    userName: state.user.userName,
    isAuthenticated: state.user.isAuthenticated
  })

  return connect(mapStateToProps)(AuthenticatedComponent)
}



// WEBPACK FOOTER //
// ./src/containers/HOC/AuthenticatedComponent.js